import '@caresend/types';
import '@caresend/utils';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../ui/Icon.vue.js';
import '../../../../functions/configuration/icons.js';
import '../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../functions/tracking/index.js';
import 'dayjs';
import '../../../../router/helpers/initRouter.js';
import 'file-saver';
import '../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../database/encryption/model.js';
import 'js-sha256';
import 'firebase/auth';
import '../../../../database/firebaseConfig/init.js';
import '../../../../database/firebaseConfig/methods.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import '../store/portal/index.js';

// All of this only applies to the users search at the moment
// TODO: The `useItineraryGeoSearch` file needs to be split into separate
// files for each type of search as it is too bloated
/**
 * The fetch type for an algolia search on the portal map. This is currently
 * only being used for the users search.
 */
var GeoSearchFetchType;
(function (GeoSearchFetchType) {
    GeoSearchFetchType["FIRST_FETCH"] = "firstFetch";
    GeoSearchFetchType["RELOAD"] = "reload";
    GeoSearchFetchType["PAGINATION"] = "pagination";
})(GeoSearchFetchType || (GeoSearchFetchType = {}));
const LARGE_USERS_RESULT_SIZE = 100;
const getClampedBounds = (coords) => {
    const { minLat, maxLat, minLng, maxLng } = coords;
    return {
        minLat: Math.max(-90, Math.min(90, minLat)),
        maxLat: Math.max(-90, Math.min(90, maxLat)),
        minLng: Math.max(-180, Math.min(180, minLng)),
        maxLng: Math.max(-180, Math.min(180, maxLng)),
    };
};
const getIsInvalidBounds = (coords) => {
    const clampedBounds = getClampedBounds(coords);
    return clampedBounds.maxLng - clampedBounds.minLng > 180
        || clampedBounds.maxLat - clampedBounds.minLat > 90;
};

export { GeoSearchFetchType, LARGE_USERS_RESULT_SIZE, getClampedBounds, getIsInvalidBounds };
